import { Factsheet } from '@bepatient/factsheet-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FactsheetActions, FactsheetActionTypes } from './factsheet.actions';

interface FactsheetState {
  factsheet: Factsheet;
}

export const factsheetInitialState: FactsheetState = {
  factsheet: undefined
};

export function factsheetReducer(
  state = factsheetInitialState,
  action: FactsheetActions
): FactsheetState {
  switch (action.type) {
    case FactsheetActionTypes.LOAD_FACTSHEET:
      return { ...state, factsheet: void 0 };

    case FactsheetActionTypes.LOAD_FACTSHEET_SUCCESS:
      return { ...state, factsheet: action.payload };

    default:
      return state;
  }
}

const factsheetState = createFeatureSelector<FactsheetState>('factsheet');

export const selectorFactsheetFactsheet = createSelector(
  factsheetState,
  state => state.factsheet
);
